/**
 * Nordic Park — Scroll to Reviews
 * Shared by hero badge and trust bar review links.
 * Usage: add data-np-scroll-reviews to any clickable element.
 */
(function () {
  function scrollToReviews() {
    var target =
      document.querySelector('[id*="loox-agg"]') ||
      document.querySelector('.loox-reviews-content') ||
      document.querySelector('[class*="loox-agg"]') ||
      document.querySelector('[id*="1768585722be6a3bc5"]');

    if (!target) {
      var headings = document.querySelectorAll('h2');
      for (var i = 0; i < headings.length; i++) {
        var text = headings[i].textContent.toLowerCase();
        if (text.indexOf('review') !== -1 || text.indexOf('customer') !== -1) {
          target = headings[i];
          break;
        }
      }
    }

    if (target) {
      var offset = 80;
      var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  }

  document.querySelectorAll('[data-np-scroll-reviews]').forEach(function (el) {
    el.addEventListener('click', scrollToReviews);
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        scrollToReviews();
      }
    });
  });
})();
